import { render } from "./appfootervue.vue?vue&type=template&id=70420cd6"
import script from "./appfootervue.vue?vue&type=script&lang=js"
export * from "./appfootervue.vue?vue&type=script&lang=js"

import "./appfootervue.vue?vue&type=style&index=0&id=70420cd6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__